'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = '/signup-v2/';
module.exports = exports['default'];